import * as React from 'react';
import { visualize, story, snap } from 'storybook-snapper';
import {
  ErrorAppearance,
  ErrorMessageWrapper,
  ErrorMessageWrapperProps,
} from '.';
import { st, classes } from './ErrorMessageWrapper.visual.st.css';

const sampleMessage = 'This is an error message!';
const sampleLongMessage =
  'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.';
const sampleMessageId = 'error-message-element';

const ErrorExample: React.FunctionComponent<ErrorMessageWrapperProps> = (
  props,
) => (
  <>
    <ErrorMessageWrapper {...props}>
      <input
        className={st(classes.input, {}, props.visible && classes.errorBorder)}
      />
    </ErrorMessageWrapper>
    <div className={classes.elementBelow}>
      An element below to show the spacing
    </div>
  </>
);

const ErrorExampleNoChildren: React.FunctionComponent<
  ErrorMessageWrapperProps
> = (props) => (
  <>
    <input
      className={st(classes.input, {}, props.visible && classes.errorBorder)}
    />
    <ErrorMessageWrapper {...props} />
    <div className={classes.elementBelow}>
      An element below to show the spacing
    </div>
  </>
);

visualize('ErrorMessageWrapper', () => {
  story('basic', () => {
    snap(
      'default',
      <ErrorExample
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={classes.wrapper}
      />,
    );
    snap(
      'minHeight',
      <ErrorExample
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.minHeight)}
      />,
    );
    snap(
      'long text',
      <ErrorExample
        visible
        message={sampleLongMessage}
        messageId={sampleMessageId}
        className={classes.wrapper}
      />,
    );
    snap(
      'hidden',
      <ErrorExample
        message={sampleMessage}
        messageId={sampleMessageId}
        className={classes.wrapper}
      />,
    );
    snap(
      'hidden with minHeight',
      <ErrorExample
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.minHeight)}
      />,
    );
    snap(
      'long text with minHeight',
      <ErrorExample
        visible
        message={sampleLongMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.minHeight)}
      />,
    );
    snap(
      'rtl',
      <ErrorExample
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.rtl)}
      />,
    );
    snap(
      'no children',
      <ErrorExampleNoChildren
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={classes.wrapper}
      />,
    );
  });

  story('Appearance: BackgroundAndBorder', () => {
    snap(
      `sanity - white background`,
      <div
        style={{
          backgroundColor: 'white',
          padding: 10,
        }}
      >
        <ErrorExample
          errorAppearance={ErrorAppearance.BackgroundAndBorder}
          visible
          message={sampleLongMessage}
          messageId={sampleMessageId}
          className={classes.wrapper}
        />
      </div>,
    );
    snap(
      `sanity - black background`,
      <div
        style={{
          backgroundColor: 'black',
          padding: 10,
        }}
      >
        <ErrorExample
          errorAppearance={ErrorAppearance.BackgroundAndBorder}
          visible
          message={sampleLongMessage}
          messageId={sampleMessageId}
          className={classes.wrapper}
        />
      </div>,
    );
    snap(
      'hidden',
      <ErrorExample
        errorAppearance={ErrorAppearance.BackgroundAndBorder}
        message={sampleMessage}
        messageId={sampleMessageId}
        className={classes.wrapper}
      />,
    );
    snap(
      'borderColorOpacity',
      <ErrorExample
        errorAppearance={ErrorAppearance.BackgroundAndBorder}
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.borderColorOpacity)}
      />,
    );
    snap(
      'borderRadius',
      <ErrorExample
        errorAppearance={ErrorAppearance.BackgroundAndBorder}
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.borderRadius)}
      />,
    );
    snap(
      'borderWidth',
      <ErrorExample
        errorAppearance={ErrorAppearance.BackgroundAndBorder}
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.borderWidth)}
      />,
    );
    snap(
      'backgroundColorOpacity',
      <ErrorExample
        errorAppearance={ErrorAppearance.BackgroundAndBorder}
        visible
        message={sampleMessage}
        messageId={sampleMessageId}
        className={st(classes.wrapper, {}, classes.backgroundColorOpacity)}
      />,
    );
  });
});
